export const getApplication = state => state.getApplicationReducer;

export const getApplicationForm = state => getApplication(state).appForm;

export const getApplicationDetail = state => getApplication(state).applicantDetails;

export const getMain = state => state.main;
